import { NgModule } from '@angular/core';
import { ScrollableToggleGroupComponent } from '@exl-ng/mulo-common';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedModule } from '../../shared/shared.module';
import { MultiLanguageComponent } from './multi-language.component';

@NgModule({
    imports: [
        SharedModule,
        NgxMatSelectSearchModule,
        ScrollableToggleGroupComponent,
        MultiLanguageComponent,
    ],
    exports: [MultiLanguageComponent],
})
export class MultiLanguageModule {}
